import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquare } from '@fortawesome/pro-regular-svg-icons';

library.add(faSquare);